import { useContext } from "react";

import {
    type ISharedContentProps,
    SharedContentContext,
} from "entity/sharedContent/SharedContentProvider";

export const useSharedContent = (): ISharedContentProps => {
    const context = useContext(SharedContentContext);
    if (!context) {
        return { shareToken: undefined };
    }
    return context;
};
